module.exports = __webpack_public_path__ + "static/media/mercadolivre.4174b975.png";